import {
  TOGGLE_EXPORT_MODE, TOGGLE_EDIT_MODE, TOGGLE_CARD_VIEW, TOGGLE_CUSTOMIZE_MODE,
  TOGGLE_MODAL_EDIT_MODE, TOGGLE_SELECT_MODE, SAVE_TABLE_COLUMN_SETTINGS, SAVE_WIDGET_SETTINGS,
} from '../../../constants/system/actions';

const toggleExportMode: Function = (payload: boolean): ReduxAction => ({
  type: TOGGLE_EXPORT_MODE, payload,
});

const toggleEditMode: Function = (payload: boolean): ReduxAction => ({
  type: TOGGLE_EDIT_MODE, payload,
});

const toggleCardView: Function = (payload: boolean): ReduxAction => ({
  type: TOGGLE_CARD_VIEW, payload,
});

const toggleCustomizeMode: Function = (payload: boolean): ReduxAction => ({
  type: TOGGLE_CUSTOMIZE_MODE, payload,
});

const toggleModalEditMode: Function = (payload: boolean): ReduxAction => ({
  type: TOGGLE_MODAL_EDIT_MODE, payload,
});

const toggleSelectMode: Function = (payload: boolean): ReduxAction => ({
  type: TOGGLE_SELECT_MODE, payload,
});

const saveTableColumnSettings: Function = (
  payload?: ActionPayload, resolve?: Function, reject?: Function,
): ReduxAction => ({
  type: SAVE_TABLE_COLUMN_SETTINGS, payload, resolve, reject,
});

const saveWidgetSettings: Function = (payload?: ActionPayload, resolve?: Function, reject?: Function): ReduxAction => ({
  type: SAVE_WIDGET_SETTINGS, payload, resolve, reject,
});

export {
  toggleExportMode,
  toggleEditMode,
  toggleCardView,
  toggleCustomizeMode,
  toggleModalEditMode,
  toggleSelectMode,
  saveTableColumnSettings,
  saveWidgetSettings,
};
